<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';

const { fileType } = defineProps({
  fileType: {
    type: String,
    required: true,
  },
});

const fileTypeIcon = computed(() => {
  const fileIconMap = {
    '7z': 'i-hichat-file-zip',
    csv: 'i-hichat-file-csv',
    doc: 'i-hichat-file-doc',
    docx: 'i-hichat-file-doc',
    json: 'i-hichat-file-txt',
    odt: 'i-hichat-file-doc',
    pdf: 'i-hichat-file-pdf',
    ppt: 'i-hichat-file-ppt',
    pptx: 'i-hichat-file-ppt',
    rar: 'i-hichat-file-zip',
    rtf: 'i-hichat-file-doc',
    tar: 'i-hichat-file-zip',
    txt: 'i-hichat-file-txt',
    xls: 'i-hichat-file-xls',
    xlsx: 'i-hichat-file-xls',
    zip: 'i-hichat-file-zip',
  };

  return fileIconMap[fileType] || 'i-teenyicons-text-document-solid';
});
</script>

<template>
  <Icon :icon="fileTypeIcon" />
</template>
